import*as React$1 from'react';import React__default,{useState,useRef,useEffect,Component,useCallback,useMemo}from'react';import ReactDOM from'react-dom';import {Modal}from'antd';function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}var classnames = {exports: {}};/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames () {
			var classes = '';

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue(arg));
				}
			}

			return classes;
		}

		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return arg;
			}

			if (typeof arg !== 'object') {
				return '';
			}

			if (Array.isArray(arg)) {
				return classNames.apply(null, arg);
			}

			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}

			var classes = '';

			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, key);
				}
			}

			return classes;
		}

		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}()); 
} (classnames));

var classnamesExports = classnames.exports;
var classNames = /*@__PURE__*/getDefaultExportFromCjs(classnamesExports);/**
 * 按钮基类
 * @param props
 * @returns
 */
function ButtonBase(props) {
    const { icon, onClick, wrapClassName, style, disabled, children } = props;
    return (React__default.createElement("button", { className: classNames({
            "button-base": true,
            "disabled": disabled
        }, wrapClassName), style: style, onClick: onClick },
        icon && React__default.createElement("span", { className: "icon" }, icon),
        React__default.createElement("span", null, children)));
}/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};/**
 * 默认按钮
 * @param props
 * @returns
 */
function Button(props) {
    const { primary, danger, small, active } = props, rest = __rest(props, ["primary", "danger", "small", "active"]);
    return (React__default.createElement(ButtonBase, Object.assign({}, rest, { wrapClassName: classNames({
            "text-button": true,
            "small": small,
            "primary": primary,
            "danger": danger,
            "active": active,
        }, rest.wrapClassName) })));
}/**
 * 一级导航按钮
 * @param props
 * @returns
 */
function NavFirstLevelButton(props) {
    const { active } = props, rest = __rest(props, ["active"]);
    return (React__default.createElement(ButtonBase, Object.assign({}, rest, { wrapClassName: classNames({
            "nav-first-level-button": true,
            "active": active
        }, rest.wrapClassName) })));
}/**
 * 二级导航按钮
 * @param props
 * @returns
 */
function NavSecondLevelButton(props) {
    const rest = __rest(props, []);
    return (React__default.createElement(ButtonBase, Object.assign({}, rest, { wrapClassName: classNames({ "nav-second-level-button": true }, rest.wrapClassName) })));
}/**
 * 二级导航标签
 */
function NavSecondLevelTag(props) {
    const rest = __rest(props, []);
    return (React__default.createElement(ButtonBase, Object.assign({}, rest, { wrapClassName: classNames({ "nav-second-level-tag": true }, rest.wrapClassName) })));
}var _g$5, _defs$2;
function _extends$h() { return _extends$h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$h.apply(null, arguments); }
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    fill: "none"
  }, props), _g$5 || (_g$5 = /*#__PURE__*/React$1.createElement("g", {
    clipPath: "url(#arrow_svg__a)"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "#11788F",
    d: "M4.39 7.123a.5.5 0 0 1-.78 0L.32 3.007a.5.5 0 0 1 .39-.813h6.58a.5.5 0 0 1 .39.813z"
  }))), _defs$2 || (_defs$2 = /*#__PURE__*/React$1.createElement("defs", null, /*#__PURE__*/React$1.createElement("clipPath", {
    id: "arrow_svg__a"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "#fff",
    d: "M0 0h8v8H0z"
  })))));
};/**
 * 二级导航菜单
 */
function NavSecondLevelMenu(props) {
    const { options, value, onChange, wrapClassName, style } = props, rest = __rest(props, ["options", "value", "onChange", "wrapClassName", "style"]);
    const [open, setOpen] = useState(false); // 控制下拉框展开/收起
    const dropdownRef = useRef(null); // 组件引用，处理外部点击
    // 切换下拉框展开/收起状态
    const toggleDropdown = () => {
        setOpen(!open);
    };
    // 处理选项点击
    const handleSelect = (value) => {
        setOpen(false);
        if (onChange) {
            onChange(value);
        }
    };
    // 点击外部时关闭下拉框
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    return (React__default.createElement("div", { ref: dropdownRef, className: classNames("nav-second-level-dropdown", wrapClassName), style: style },
        React__default.createElement("div", { className: "dropdown-header", onClick: toggleDropdown },
            React__default.createElement(ButtonBase, Object.assign({}, rest, { style: { marginRight: '0px' }, wrapClassName: classNames({ "nav-second-level-button": true }, wrapClassName) })),
            React__default.createElement("span", { className: classNames("dropdown-icon", { open }) },
                React__default.createElement(SvgArrow, null))),
        open && (React__default.createElement("div", { className: "dropdown-menu" }, options.length > 0 ? (options.map(option => (React__default.createElement("div", { key: option.value, className: classNames("dropdown-item", {
                selected: option.value === value
            }), onClick: () => handleSelect(option.value) }, option.label)))) : (React__default.createElement("div", { className: "dropdown-empty" }, "\u65E0\u5339\u914D\u9009\u9879"))))));
}/**
 * 三级导航按钮
 * @param props
 * @returns
 */
function NavThirdLevelButton(props) {
    const { active } = props, rest = __rest(props, ["active"]);
    return (React__default.createElement(ButtonBase, Object.assign({}, rest, { wrapClassName: classNames({
            "nav-third-level-button": true,
            "active": active
        }, rest.wrapClassName) })));
}/**
 * 图标按钮
 * @param props
 * @returns
 */
function IconButton(props) {
    const { small, active } = props, rest = __rest(props, ["small", "active"]);
    return (React__default.createElement(ButtonBase, Object.assign({}, rest, { wrapClassName: classNames({
            "icon-button": true,
            "small": small,
            "active": active,
        }, rest.wrapClassName) })));
}/**
 * 中文名：输入框
 * Input 组件
 *
 * 该组件提供一个自定义输入框，支持多种事件回调和不同的状态。
 *
 */
const normalizeSize = (value) => {
    return typeof value === 'number' ? `${value}px` : value;
};
/**
 * 中文名：通用输入框组件
 * 自定义的通用输入框组件
 */
function Input(props) {
    const { value, onChange, onEnter, onFocus, onBlur, placeholder, disabled, warning = false, style, wrapClassName, readOnly, autoFocus, label, unit, width, height, defaultValue, prefix } = props;
    const [isFocused, setIsFocused] = useState(false);
    const handleFocus = (e) => {
        if (!disabled) {
            setIsFocused(true);
            onFocus === null || onFocus === void 0 ? void 0 : onFocus(e); // 使用可选链调用
        }
    };
    const handleBlur = (e) => {
        if (!disabled) {
            setIsFocused(false);
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(e); // 使用可选链调用
        }
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            onEnter === null || onEnter === void 0 ? void 0 : onEnter(e); // 使用可选链调用
        }
    };
    return (React__default.createElement("div", { className: classNames('input-container', wrapClassName), style: style },
        !!prefix && prefix,
        label && React__default.createElement("span", { className: "input-label" }, label),
        React__default.createElement("input", { readOnly: readOnly, className: classNames('input-box', {
                focus: isFocused,
                blur: !isFocused && value !== '',
                disabled,
                warning,
            }), type: "text", value: value, onChange: onChange, onKeyDown: handleKeyDown, onFocus: handleFocus, onBlur: handleBlur, placeholder: placeholder, disabled: disabled, autoFocus: autoFocus, style: {
                width: normalizeSize(width), // 自动处理宽度单位
                height: normalizeSize(height), // 自动处理高度单位
            }, defaultValue: defaultValue }),
        unit && React__default.createElement("span", { className: "input-unit" }, unit)));
}/**
 * 通用侧边栏标题组件
 * @param props
 * @returns
 */
function SideHeader(props) {
    const { onClose, children, wrapClassName, style } = props;
    return (React__default.createElement("div", { className: classNames({ 'side-header': true }, wrapClassName), style: style },
        React__default.createElement("span", { className: "side-header-title" }, children)));
}var _path$a;
function _extends$g() { return _extends$g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$g.apply(null, arguments); }
var SvgDropdown = function SvgDropdown(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$a || (_path$a = /*#__PURE__*/React$1.createElement("path", {
    fill: "#222627",
    d: "M8.396 10.485a.5.5 0 0 1-.792 0l-2.448-3.18a.5.5 0 0 1 .396-.805h4.896a.5.5 0 0 1 .396.805z"
  })));
};var _path$9;
function _extends$f() { return _extends$f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$f.apply(null, arguments); }
var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React$1.createElement("path", {
    stroke: "#222627",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m3.757 3.757 8.486 8.486M12.243 3.757l-8.486 8.486"
  })));
};function Dropdown(props) {
    var _a;
    const { options, placeholder, onChange, wrapClassName, style } = props;
    const [open, setOpen] = useState(false); // 控制下拉框展开/收起
    const [selectedValue, setSelectedValue] = useState(props.value == null ? (props.defaultValue || "") : props.value); // 当前选中值
    const dropdownRef = useRef(null); // 组件引用，处理外部点击
    const [searchQuery, setSearchQuery] = useState(''); // 搜索框的输入内容
    const inputRef = useRef(null); // 搜索框引用
    // 同步选中值
    useEffect(() => {
        setSelectedValue(props.value);
    }, [props.value]);
    // 切换下拉框展开/收起状态
    const toggleDropdown = () => {
        setOpen(!open);
        if (!open) {
            // 打开下拉框时聚焦输入框
            setTimeout(() => { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 0);
        }
    };
    // 处理选项点击
    const handleSelect = (value) => {
        setSelectedValue(value);
        setOpen(false);
        setSearchQuery('');
        if (onChange) {
            onChange(value);
        }
    };
    // 处理搜索框的输入
    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
    };
    // 过滤选项
    const filteredOptions = options.filter(option => { var _a; return (_a = option === null || option === void 0 ? void 0 : option.label) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.toLowerCase()); });
    // 点击外部时关闭下拉框
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    return (React__default.createElement("div", { ref: dropdownRef, className: classNames("custom-dropdown", wrapClassName), style: style },
        React__default.createElement("div", { className: "dropdown-header", onClick: toggleDropdown },
            React__default.createElement("input", { ref: inputRef, type: "text", 
                // value={open ? searchQuery : (selectedValue ? options.find(opt => opt.value === selectedValue)?.label || '' : '')}
                value: open ? searchQuery : (selectedValue ? ((_a = options.find(opt => opt.value === selectedValue)) === null || _a === void 0 ? void 0 : _a.label) || '' : searchQuery), onChange: handleSearch, placeholder: placeholder || "请选择", readOnly: !open, className: classNames("dropdown-input", { open }) }),
            props.couldCancel && selectedValue && selectedValue.length > 0 &&
                React__default.createElement("span", { className: classNames("dropdown-icon", "dropdown-cancel"), onClick: (e) => {
                        e.stopPropagation(); //组织点击事件冒泡
                        handleSelect(""); //清空选项
                    } },
                    React__default.createElement(SvgCancel, null)),
            React__default.createElement("span", { className: classNames("dropdown-icon", { open }) },
                React__default.createElement(SvgDropdown, null))),
        open && (React__default.createElement("div", { className: "dropdown-menu" }, filteredOptions.length > 0 ? (filteredOptions.map(option => (React__default.createElement("div", { key: option.value, className: classNames("dropdown-item", {
                dropSelected: option.value === selectedValue
            }), onClick: () => handleSelect(option.value) }, option.label)))) : (React__default.createElement("div", { className: "dropdown-empty" }, "\u65E0\u5339\u914D\u9009\u9879"))))));
}function InputDropdown(props) {
    const { options, placeholder, onChange, wrapClassName, style } = props;
    const [open, setOpen] = useState(false); // 控制下拉框展开/收起
    const [selectedValue, setSelectedValue] = useState(props.value == null ? (props.defaultValue || "") : props.value); // 当前选中值
    const dropdownRef = useRef(null); // 组件引用，处理外部点击
    const [searchQuery, setSearchQuery] = useState(props.value || ''); // 搜索框的输入内容
    const inputRef = useRef(null); // 搜索框引用
    // 同步选中值
    useEffect(() => {
        setSelectedValue(props.value || '');
        setSearchQuery(props.value || '');
    }, [props.value]);
    // 切换下拉框展开/收起状态
    const toggleDropdown = () => {
        setOpen(!open);
        if (!open) {
            // 打开下拉框时聚焦输入框
            setTimeout(() => { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 0);
        }
    };
    // 处理选项点击
    const handleSelect = (value) => {
        setSelectedValue(value);
        setSearchQuery(value); // 更新输入框内容为选中值
        setOpen(false);
        if (onChange) {
            onChange(value);
        }
    };
    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchQuery(value);
        if (onChange) {
            onChange(value);
        }
    };
    // 过滤选项
    const filteredOptions = options.filter(option => option.label.toLowerCase().includes(searchQuery.toLowerCase()));
    // 点击外部时关闭下拉框
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    return (React__default.createElement("div", { ref: dropdownRef, className: classNames("custom-dropdown", wrapClassName), style: style },
        React__default.createElement("div", { className: "dropdown-header", onClick: toggleDropdown },
            React__default.createElement("input", { ref: inputRef, type: "text", 
                // value={open ? searchQuery : (selectedValue ? options.find(opt => opt.value === selectedValue)?.label || '' : '')}
                // value={open ? searchQuery : (selectedValue ? options.find(opt => opt.value === selectedValue)?.label || '' : searchQuery)}
                value: searchQuery, onChange: handleInputChange, placeholder: placeholder || "请选择", className: classNames("dropdown-input", { open }) }),
            React__default.createElement("span", { className: classNames("dropdown-icon", { open }) },
                React__default.createElement(SvgDropdown, null))),
        open && (React__default.createElement("div", { className: "dropdown-menu" }, filteredOptions.length > 0 ? (filteredOptions.map(option => (React__default.createElement("div", { key: option.value, className: classNames("dropdown-item", {
                dropSelected: option.value === selectedValue
            }), onClick: () => handleSelect(option.value) }, option.label)))) : (React__default.createElement("div", { className: "dropdown-empty" }, "\u65E0\u5339\u914D\u9009\u9879"))))));
}const MOUSE$1 = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
};
function ContextMenu(props) {
    // 定义状态
    let [container, setContainer] = useState(null); // 用于保存菜单的 DOM 容器
    let [bottom, setBottom] = useState(); // 菜单的底部位置（用于自动调整）
    let [right, setRight] = useState(); // 菜单的右侧位置（用于自动调整）
    const ref = useRef(); // 保存菜单的 DOM 引用
    const [menuWidth, setMenuWidth] = useState(null); // 保存菜单实际宽度
    useEffect(() => {
        document.addEventListener('keydown', onKeyup); // 注册键盘事件
        if (props.forceRender) {
            let container = document.createElement('div'); // 创建一个容器 DOM 节点
            setContainer(container);
            document.body.appendChild(container); // 将容器添加到 body
        }
        return () => {
            var _a;
            (_a = container === null || container === void 0 ? void 0 : container.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(container); // 销毁时清理 DOM 节点
            document.removeEventListener('keydown', onKeyup); // 移除键盘事件
        };
    }, []);
    const onKeyup = (event) => {
        let keyCode = event.keyCode; // 获取按键码
        if (keyCode === 27) {
            // Escape 键
            if (props.onEscape) {
                props.onEscape(); // 调用 Escape 的回调
            }
        }
    };
    useEffect(() => {
        if (!!props.visible) {
            // 如果菜单可见且容器不存在
            if (container == null) {
                container = document.createElement('div');
                setContainer(container);
            }
            document.body.appendChild(container);
        }
        if (!props.visible && !props.forceRender) {
            // 菜单不可见且未强制渲染时
            container === null || container === void 0 ? void 0 : container.parentElement.removeChild(container);
            setContainer(null);
        }
    }, [props.visible]);
    useEffect(() => {
        var _a;
        if (!ref.current)
            return;
        // 获取容器的实际宽度（如果没有传递 width）
        if (!props.width) {
            setMenuWidth(((_a = ref.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || null); // 获取子元素撑开的宽度
        }
        let clientH = document.body.clientHeight; // 获取屏幕高度
        if (props.autoAdjust && ref.current.clientHeight + props.top > clientH) {
            // 自动调整菜单高度
            setBottom(clientH - props.top);
        }
        else {
            setBottom(null);
        }
        let clientW = document.body.clientWidth; // 获取屏幕宽度
        if (props.autoAdjust && props.left + ref.current.clientWidth > clientW) {
            // 自动调整菜单宽度
            setRight(0);
        }
        else {
            setRight(null);
        }
    }, [props.visible, container, props.width, menuWidth]);
    const onClick = (e) => {
        if (e.button === MOUSE$1.LEFT) {
            if (checkClickInBound(e))
                return;
            if (props.onCancel) {
                props.onCancel();
            }
        }
    };
    const onRightClick = (e) => {
        if (props.onRightClick) {
            e.preventDefault();
            props.onRightClick(e);
        }
        else if (props.onCancel) {
            e.preventDefault();
            props.onCancel();
        }
    };
    const checkClickInBound = (e) => {
        var _a;
        let bound = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (!bound)
            return false;
        let x = e.clientX;
        let y = e.clientY;
        return x > bound.left && x < bound.right && y > bound.top && y < bound.bottom;
    };
    let modal = (React__default.createElement("div", { className: classNames({
            'context-menu-container': true,
            'visible': props.visible,
            'mask': props.mask,
        }), onClick: onClick, onContextMenu: e => onRightClick(e), style: props.maskStyle },
        React__default.createElement("div", { className: `context-menu-wrapper ${props.wrapperClassname || ''}`, ref: ref, style: {
                left: right == null ? props.left : null,
                top: bottom == null ? props.top : null,
                bottom: bottom,
                right: right,
                width: props.width || menuWidth,
            } }, props.children)));
    return ((props.visible || props.forceRender) &&
        container &&
        (ReactDOM.createPortal(!!props.modalRender ? props.modalRender(modal) : modal, container)));
}
ContextMenu.defaultProps = {
    mask: true,
    forceRender: false,
    left: 0,
    top: 0,
    autoAdjust: true,
};const MOUSE = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
};
class ContextMenuModal extends Component {
    constructor() {
        super(...arguments);
        this.ref = React__default.createRef();
        this.state = {
            container: null
        };
        this.onClick = (event) => {
            if (event.button === MOUSE.LEFT) {
                if (this.checkClickInBound(event))
                    return;
                if (this.props.onCancel) {
                    this.props.onCancel();
                }
            }
        };
        this.onRightClick = (event) => {
            event.preventDefault();
            if (this.props.onRightClick) {
                this.props.onRightClick();
            }
        };
        this.checkClickInBound = (event) => {
            var _a, _b;
            let bound = (_b = (_a = this.ref) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
            if (!bound)
                return false;
            let x = event.clientX;
            let y = event.clientY;
            return x > bound.left && x < bound.right && y > bound.top && y < bound.bottom;
        };
        this.onKeyup = (event) => {
            let keyCode = event.keyCode;
            if (keyCode === 27) {
                //escape
                if (this.props.onEscape) {
                    this.props.onEscape();
                }
            }
        };
    }
    componentDidMount() {
        document.addEventListener('keydown', this.onKeyup);
        if (this.props.forceRender) {
            let container = document.createElement('div');
            this.setState({
                container: container
            });
            document.body.appendChild(container);
        }
    }
    componentDidUpdate() {
        if (this.props.forceRender)
            return;
        if (this.props.visible !== this.visible && !!this.props.visible) {
            this.visible = this.props.visible;
            let container = document.createElement('div');
            // container.classList.add('context-menu-container')
            // container.addEventListener('click', this.onCancel)
            this.setState({
                container: container
            });
            document.body.appendChild(container);
            // ReactDOM.createPortal(this.props.children, this.container);
        }
        else if (!this.props.visible && this.state.container) {
            this.visible = this.props.visible;
            this.state.container.parentElement.removeChild(this.state.container);
            // this.state.container.removeEventListener('click', this.onCancel);
            this.setState({
                container: null,
            });
        }
    }
    componentWillUnmount() {
        if (this.state.container) {
            this.state.container.parentElement.removeChild(this.state.container);
            // this.state.container.removeEventListener('click', this.onCancel);
        }
        document.removeEventListener('keyup', this.onKeyup);
    }
    render() {
        if (this.props.forceRender) {
            return (this.state.container && (ReactDOM.createPortal(React__default.createElement("div", { className: classNames({
                    'context-menu-container': true,
                    'mask': this.props.mask,
                    'renderVisible': this.props.visible,
                }), onClick: this.onClick, onContextMenu: this.onRightClick },
                React__default.createElement("div", { className: `context-menu-wrapper ${this.props.wrapperClassname || ''}`, ref: this.ref, style: {
                        left: this.props.left,
                        top: this.props.top,
                        bottom: this.props.bottom,
                        right: this.props.right,
                        width: this.props.width,
                    } }, this.props.children)), this.state.container)));
        }
        return (this.props.visible &&
            this.state.container &&
            (ReactDOM.createPortal(React__default.createElement("div", { className: classNames({
                    'context-menu-container': true,
                    'visible': true,
                    'mask': this.props.mask,
                }), onClick: this.onClick, onContextMenu: this.onRightClick },
                React__default.createElement("div", { className: `context-menu-wrapper ${this.props.wrapperClassname || ''}`, ref: this.ref, style: {
                        left: this.props.left,
                        top: this.props.top,
                        bottom: this.props.bottom,
                        right: this.props.right,
                        width: this.props.width,
                    } }, this.props.children)), this.state.container)));
    }
}
ContextMenuModal.defaultProps = {
    mask: true,
    forceRender: false,
};function ContextMenuWrapper(props) {
    const [left, setLeft] = useState(0);
    const [top, setTop] = useState(0);
    const [visible, setVisible] = useState(false);
    const ref = useRef();
    const childrenRef = useRef();
    const [menuWidth, setMenuWidth] = useState(null); // 保存菜单实际宽度
    const onTrigger = () => {
        if (props.onVisibleChange) {
            if (props.visible != null) {
                props.onVisibleChange(!props.visible);
            }
            else {
                props.onVisibleChange(!visible);
                setVisible(!visible);
            }
        }
        else {
            setVisible(!visible);
        }
    };
    useEffect(() => {
        var _a;
        let ele = ref.current;
        if (ele == null)
            return;
        // 获取容器的实际宽度（如果没有传递 width）
        if (!props.width) {
            setMenuWidth(((_a = ref.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || null); // 获取子元素撑开的宽度
        }
        let bound = ele.getBoundingClientRect();
        let clientX = bound.left;
        setLeft(clientX);
        let clientY = bound.bottom;
        let bodyH = document.body.clientHeight;
        let height = props.height;
        if (clientY + height > bodyH) {
            clientY = bound.top - height - 5;
        }
        else {
            clientY += 5;
        }
        setTop(clientY);
    }, [props.visible, visible]);
    return (React__default.createElement("div", { ref: ref },
        React__default.createElement("div", { onClick: onTrigger }, props.container),
        React__default.createElement(ContextMenu, { visible: props.visible == null ? visible : props.visible, left: left, top: top, width: props.width || menuWidth, wrapperClassname: `context-menu-wrapper ${props.wrapperClassname || ''}`, onCancel: props.closable ? onTrigger : null, maskStyle: props.maskStyle },
            React__default.createElement("div", { ref: childrenRef, style: {
                    maxHeight: `${props.height || 300}px`,
                    height: props.height != null ? `${props.height}px` : null,
                    overflow: 'auto'
                } }, props.children))));
}
ContextMenuWrapper.defaultProps = {
    width: 250,
    closable: true,
};function MenuList({ children, wrapClassName, style }) {
    return (React__default.createElement("div", { className: classNames({
            "menu-list": true,
        }, wrapClassName), style: style }, children));
}function MenuItem(props) {
    const { children, wrapClassName, onClick, special, style, disabled } = props;
    const handleClick = (e) => {
        if (disabled) {
            e.preventDefault();
            e.stopPropagation();
            return; // 阻止事件传播并不触发 `onClick`
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    return (React__default.createElement("div", { className: classNames({
            "menu-item": true,
            "special": special,
            'disabled': disabled,
        }, wrapClassName), onClick: handleClick, style: style }, children));
}var _path$8;
function _extends$e() { return _extends$e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$e.apply(null, arguments); }
var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React$1.createElement("path", {
    stroke: "#6B7375",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m6.437 4.792 3.126 3.142-3.126 3.275"
  })));
};/**
 * 通用面包屑组件
 * @param props
 * @returns
 */
function Breadcrumb(props) {
    const { items, separator = React__default.createElement(SvgBack, null), wrapClassName, style } = props;
    return (React__default.createElement("div", { className: classNames('breadcrumb', wrapClassName), style: style }, items.map((item, index) => (React__default.createElement("span", { key: index, className: "breadcrumb-item" },
        item.onClick ? (React__default.createElement("span", { className: "breadcrumb-item-link", onClick: item.onClick }, item.label)) : (React__default.createElement("span", { className: "breadcrumb-item-text" }, item.label)),
        index < items.length - 1 && (React__default.createElement("span", { className: "breadcrumb-separator" }, separator)))))));
}var _path$7;
function _extends$d() { return _extends$d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$d.apply(null, arguments); }
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 24,
    fill: "none"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React$1.createElement("path", {
    fill: "#11788F",
    fillRule: "evenodd",
    d: "M45.556 5v1.77c-3.423 0-9.023 3.247-9.023 7.97h-4.355c0-4.723-5.023-7.97-9.022-7.97-4.311 0-9.334 3.247-9.334 7.97H9.778C9.363 12.082 6.916 6.77.444 6.77V5c2.49 0 4.77.984 5.6 1.476q.099.065.208.14c1.026.696 2.837 1.925 5.393 1.925 2.24 0 3.84-.713 4.463-1.106C17.041 6.648 19.92 5 23.156 5c3.235 0 5.906 1.648 6.736 2.435.83.682 2.224 1.106 4.464 1.106 2.8 0 4.355-.885 5.91-2.065C41.823 5.296 44.312 5 45.557 5M9.698 15.957v.608h1.446V19H12.3v-2.435h1.445v-.609zm22.556.608v-.609h4.048v.61h-1.446V19H33.7v-2.435zm-16.772-.609V19h.867v-2.13L18.662 19h.868v-3.043h-.868v2.13l-2.313-2.13zM26.47 19v-3.043h4.049v.608h-3.181v.609h1.735v.609h-1.735v.608h3.18V19zm-2.313-2.13h.578c0-.508-.347-1.522-1.735-1.522s-1.735.913-1.735 1.826S21.612 19 23 19s1.735-.812 1.735-1.217h-.578c0 .202-.29.608-1.157.608-.925 0-1.157-.53-1.157-1.217s.232-1.217 1.157-1.217 1.157.608 1.157.913",
    clipRule: "evenodd"
  })));
};var _path$6;
function _extends$c() { return _extends$c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$c.apply(null, arguments); }
var SvgLogoHover = function SvgLogoHover(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 24,
    fill: "none"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React$1.createElement("path", {
    fill: "#0354BB",
    fillRule: "evenodd",
    d: "M45.556 5v1.77c-3.423 0-9.023 3.247-9.023 7.97h-4.355c0-4.723-5.023-7.97-9.022-7.97-4.311 0-9.334 3.247-9.334 7.97H9.778C9.363 12.082 6.916 6.77.444 6.77V5c2.49 0 4.77.984 5.6 1.476q.099.065.208.14c1.026.696 2.837 1.925 5.393 1.925 2.24 0 3.84-.713 4.463-1.106C17.041 6.648 19.92 5 23.156 5c3.235 0 5.906 1.648 6.736 2.435.83.682 2.224 1.106 4.464 1.106 2.8 0 4.355-.885 5.91-2.065C41.823 5.296 44.312 5 45.557 5M9.698 15.957v.608h1.446V19H12.3v-2.435h1.445v-.609zm22.556.608v-.609h4.048v.61h-1.446V19H33.7v-2.435zm-16.772-.609V19h.867v-2.13L18.662 19h.868v-3.043h-.868v2.13l-2.313-2.13zM26.47 19v-3.043h4.049v.608h-3.181v.609h1.735v.609h-1.735v.608h3.18V19zm-2.313-2.13h.578c0-.508-.347-1.522-1.735-1.522s-1.735.913-1.735 1.826S21.612 19 23 19s1.735-.812 1.735-1.217h-.578c0 .202-.29.608-1.157.608-.925 0-1.157-.53-1.157-1.217s.232-1.217 1.157-1.217 1.157.608 1.157.913",
    clipRule: "evenodd"
  })));
};var _path$5;
function _extends$b() { return _extends$b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b.apply(null, arguments); }
var SvgLogoActive = function SvgLogoActive(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 24,
    fill: "none"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React$1.createElement("path", {
    fill: "#094D5F",
    fillRule: "evenodd",
    d: "M45.556 5v1.77c-3.423 0-9.023 3.247-9.023 7.97h-4.355c0-4.723-5.023-7.97-9.022-7.97-4.311 0-9.334 3.247-9.334 7.97H9.778C9.363 12.082 6.916 6.77.444 6.77V5c2.49 0 4.77.984 5.6 1.476q.099.065.208.14c1.026.696 2.837 1.925 5.392 1.925 2.24 0 3.842-.713 4.464-1.106C17.041 6.648 19.92 5 23.156 5c3.235 0 5.906 1.648 6.736 2.435.83.682 2.224 1.106 4.464 1.106 2.8 0 4.355-.885 5.91-2.065C41.823 5.296 44.312 5 45.557 5M9.698 15.957v.608h1.446V19H12.3v-2.435h1.445v-.609zm22.556.608v-.609h4.048v.61h-1.446V19H33.7v-2.435zm-16.772-.609V19h.867v-2.13L18.662 19h.868v-3.043h-.868v2.13l-2.313-2.13zM26.47 19v-3.043h4.049v.608h-3.181v.609h1.735v.609h-1.735v.608h3.18V19zm-2.313-2.13h.578c0-.508-.347-1.522-1.735-1.522s-1.735.913-1.735 1.826S21.612 19 23 19s1.735-.812 1.735-1.217h-.578c0 .202-.29.608-1.157.608-.925 0-1.157-.53-1.157-1.217s.232-1.217 1.157-1.217 1.157.608 1.157.913",
    clipRule: "evenodd"
  })));
};/**
 * logo组件
 * @param props
 * @returns
 */
function Logo(props) {
    const { onClick, wrapClassName, style } = props;
    return (React__default.createElement("div", { className: classNames({ 'logo': true }, wrapClassName), onClick: onClick, style: style },
        React__default.createElement("div", { className: 'logo-default' },
            React__default.createElement(SvgLogo, null)),
        React__default.createElement("div", { className: 'logo-hover' },
            React__default.createElement(SvgLogoHover, null)),
        React__default.createElement("div", { className: 'logo-active' },
            React__default.createElement(SvgLogoActive, null))));
}function ModelListItem(props) {
    const { active, name, style, showSvg, showSvgActive, children, onContextMenu, onClick, onDoubleClick, onClickShowSvg } = props;
    const clickCountRef = useRef(0); // 用于存储点击次数
    const timerRef = useRef(null); // 用于存储定时器引用
    const handleClick = () => {
        clickCountRef.current += 1;
        if (clickCountRef.current === 1) {
            // 第一次点击时启动定时器
            timerRef.current = setTimeout(() => {
                clickCountRef.current = 0; // 重置点击次数
                // 单击事件触发
                onClick();
            }, 200);
        }
        else if (clickCountRef.current === 2) {
            // 第二次点击时触发双击事件
            if (timerRef.current) {
                clearTimeout(timerRef.current); // 清理单击的定时器
                timerRef.current = null;
            }
            // 双击事件触发
            onDoubleClick();
            clickCountRef.current = 0; // 重置点击次数
        }
    };
    return (React__default.createElement("div", { className: classNames({
            'component-model-item-head': true,
            'component-model-item-head-active': active
        }), style: style, onClick: handleClick, onContextMenu: (e) => {
            if (onContextMenu) {
                onContextMenu(e);
            }
        } },
        showSvg && (React__default.createElement("div", { className: 'item-icon' },
            React__default.createElement("div", { className: classNames({
                    "show-icon": true,
                    "show-icon-show": showSvgActive,
                    "show-icon-hidden": active
                }), onClick: (e) => {
                    e.stopPropagation();
                    onClickShowSvg();
                } },
                React__default.createElement(SvgDropdown, null)),
            React__default.createElement("div", { className: classNames({
                    "show-icon-active": true,
                    "show-icon-active-show": showSvgActive,
                    "show-icon-active-hidden": !active
                }), onClick: (e) => {
                    e.stopPropagation();
                    onClickShowSvg();
                } },
                React__default.createElement(SvgDropdown, null)))),
        React__default.createElement("div", { className: 'item-name' }, name),
        React__default.createElement("div", { className: "btn-area" }, children)));
}function Tab(props) {
    const { tabs, activeKey, onChange, onClose } = props;
    const [tabList, setTabList] = useState([]);
    useEffect(() => {
        setTabList(tabs || []);
    }, [tabs]);
    /**
     * 关闭tab
     */
    const closeTab = (key) => {
        if (activeKey == key) {
            if (tabList.length == 1) {
                onChangeTab(null);
            }
            else {
                let tabIndex = tabList.findIndex(tab => tab.key == key);
                if (tabIndex + 1 == tabList.length) {
                    onChangeTab(tabList[tabIndex - 1].key);
                }
                else {
                    // 顺延往后
                    onChangeTab(tabList[tabIndex + 1].key);
                }
            }
        }
        setTabList(tabList.filter(tab => tab.key != key));
        if (onClose) {
            onClose(key);
        }
    };
    /**
     * 更新打开tab
     * @param key
     */
    const onChangeTab = (key) => {
        // setActiveKey(key)
        if (onChange) {
            onChange(key);
        }
    };
    /**
     * 中键滚动
     */
    const scrollHorizontally = useCallback((e) => {
        e.stopPropagation();
        const ele = document.getElementById("component-tab-main");
        let delta = e.deltaX || e.deltaY;
        ele.scrollLeft += delta * 2;
    }, []);
    if ((tabs === null || tabs === void 0 ? void 0 : tabs.length) <= 0)
        return null;
    return (React__default.createElement("div", { className: "component-tab-main", id: "component-tab-main", onMouseEnter: (e) => document.addEventListener("wheel", scrollHorizontally), onMouseLeave: (e) => { document.removeEventListener('wheel', scrollHorizontally); } }, tabList.map((tab, key) => (React__default.createElement("div", { key: key, className: classNames({
            "tab-item": true,
            "tab-item-active": tab.key == activeKey,
            "closable": tab.closable == null ? true : tab.closable
        }), onClick: () => {
            onChangeTab(tab.key);
        } },
        tab.value,
        (tab === null || tab === void 0 ? void 0 : tab.unSave) && (React__default.createElement("div", { className: "un-save-dot" }, "\u25CF")),
        React__default.createElement("div", { className: classNames({
                "close-svg": true,
                "display": tab.closable == null ? true : tab.closable
            }), onClick: (e) => {
                e.stopPropagation();
                closeTab(tab.key);
                if (tab.onClose) {
                    tab.onClose(e);
                }
            } },
            React__default.createElement("div", { className: "svg-show" },
                React__default.createElement(SvgCancel, null))))))));
}var _g$4;
function _extends$a() { return _extends$a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a.apply(null, arguments); }
var SvgCloseGreen = function SvgCloseGreen(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g$4 || (_g$4 = /*#__PURE__*/React$1.createElement("g", {
    stroke: "#11788F",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    clipPath: "url(#close-green_svg__clip0_1091_11544)"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "m3.757 3.757 8.486 8.486M12.243 3.757l-8.486 8.486"
  }))));
};/**
 * 浮动面板
 * @param props
 * @returns
 */
function FloatModal(props) {
    const { visible, left, top, title, titleContent, children, onClose, style, wrapClassName, width, height } = props;
    return (React__default.createElement(React__default.Fragment, null, visible && React__default.createElement("div", { className: classNames({ 'float-modal': true }, wrapClassName), style: Object.assign(Object.assign({}, style), { left, top, width: width || 340, height }) },
        props.hiddenHeader ? null :
            React__default.createElement("div", { className: 'top' },
                !!title && React__default.createElement("div", { className: 'title' }, title),
                !!titleContent && titleContent,
                React__default.createElement(IconButton, { icon: React__default.createElement(SvgCloseGreen, null), wrapClassName: 'close-icon', onClick: onClose })),
        React__default.createElement("div", { className: 'content' }, children))));
}var _rect$1, _path$4;
function _extends$9() { return _extends$9 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9.apply(null, arguments); }
var SvgRight = function SvgRight(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _rect$1 || (_rect$1 = /*#__PURE__*/React$1.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#11788F",
    rx: 2
  })), _path$4 || (_path$4 = /*#__PURE__*/React$1.createElement("path", {
    stroke: "#F9F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m2.93 6 2.155 2.155L9.07 4.169"
  })));
};function TabMenuItem(props) {
    const { active, name, onClick } = props;
    return (React__default.createElement("div", { className: classNames({
            "tab-menu-item": true,
            "tab-menu-item-active": active
        }), onClick: () => {
            onClick();
        } },
        React__default.createElement("div", { className: "tab-icon" }, active && React__default.createElement(SvgRight, null)),
        React__default.createElement("div", { className: "tab-name" }, name)));
}function SelectDot(props) {
    const { hidden, active, wrapperClassName, style, onClick } = props;
    return (React__default.createElement("div", { onClick: (e) => {
            if (onClick) {
                onClick(e);
            }
        }, className: classNames({
            'select-dot-container': true,
            'hidden': hidden,
            'active': active,
        }, wrapperClassName), style: style }));
}var _path$3;
function _extends$8() { return _extends$8 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8.apply(null, arguments); }
var SvgProjectList = function SvgProjectList(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React$1.createElement("path", {
    stroke: "#222627",
    strokeLinecap: "round",
    d: "M2.253 2.672h11.494M2.253 8h11.494M2.253 13.328h11.494"
  })));
};/**
 * 标题栏
 * @param props
 */
function Header(props) {
    const { title, onClickLogo, onClickMenu, onClickTitle, onClickAvatar, avatarUrl, username, wrapClassName, styles } = props;
    return (React__default.createElement("div", { className: classNames({ "tn-header": true }, wrapClassName), style: styles },
        React__default.createElement(Logo, { onClick: onClickLogo }),
        React__default.createElement(IconButton, { icon: React__default.createElement(SvgProjectList, null), onClick: onClickMenu, wrapClassName: "header-menu" }),
        React__default.createElement("div", { className: "tn-header-title", onClick: onClickTitle }, title),
        React__default.createElement("div", { className: "tn-header-user" },
            React__default.createElement("img", { className: "tn-avatar", src: avatarUrl, onClick: onClickAvatar }),
            React__default.createElement("span", { className: "tn-username" }, username))));
}var _path$2, _path2, _circle, _path3;
function _extends$7() { return _extends$7 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7.apply(null, arguments); }
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React$1.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13 4.368V2.5a1 1 0 0 0-1-1H2.5a1 1 0 0 0-1 1v10.438a1 1 0 0 0 1 1H6"
  })), _path2 || (_path2 = /*#__PURE__*/React$1.createElement("path", {
    stroke: "#00C2FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.563 5.313h3.812M3.563 8.313h2.343"
  })), _circle || (_circle = /*#__PURE__*/React$1.createElement("circle", {
    cx: 11.297,
    cy: 8.206,
    r: 2.05,
    stroke: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React$1.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "M14.781 14.194a3.484 3.484 0 0 0-6.969 0"
  })));
};var _g$3;
function _extends$6() { return _extends$6 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6.apply(null, arguments); }
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g$3 || (_g$3 = /*#__PURE__*/React$1.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React$1.createElement("path", {
    stroke: "#00C2FF",
    d: "M1.67 7.216h12.774"
  }), /*#__PURE__*/React$1.createElement("path", {
    stroke: "#000",
    d: "M5.877 2.75H1.556v10.5h12.66V4.38H7.243z"
  }))));
};var _g$2;
function _extends$5() { return _extends$5 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5.apply(null, arguments); }
var SvgTask = function SvgTask(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g$2 || (_g$2 = /*#__PURE__*/React$1.createElement("g", {
    stroke: "#000",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "#C5C5C5",
    d: "m7.394.69 7.067 3.23v7.538l-7.067-3.23z"
  }), /*#__PURE__*/React$1.createElement("path", {
    fill: "#D9D9D9",
    d: "m4.231 2.523 7.067 3.23v7.539l-7.067-3.23z"
  }), /*#__PURE__*/React$1.createElement("path", {
    fill: "#fff",
    d: "m1.539 4.542 7.067 3.23v7.539l-7.067-3.23z"
  }))));
};/**
 * 导航栏
 * @param props
 */
function Nav(props) {
    const { tabs, activeValue, onChange, onClickUser, onClickFile, onClickTask } = props;
    const [activeTab, setActiveTab] = React__default.useState(null);
    useEffect(() => {
        console.log('tabs', tabs);
    }, []);
    useEffect(() => {
        const tab = tabs.find(t => t.value === activeValue);
        if (!tab) {
            setActiveTab(null);
            return;
        }
        setActiveTab(tab);
    }, [activeValue]);
    const handleClick = (e, tab) => {
        if (tab.value === activeValue)
            return;
        onChange(e, tab.value);
    };
    return (React__default.createElement("div", { className: 'nav' },
        React__default.createElement("div", { className: 'nav-header' }, tabs.map(tab => {
            return React__default.createElement(NavFirstLevelButton, { key: tab.value, wrapClassName: classNames({ 'nav-btn-active': tab.value === activeValue }), onClick: (e) => handleClick(e, tab) }, tab.text);
        })),
        !activeTab && React__default.createElement("div", { className: 'nav-groups' }),
        !!activeTab && React__default.createElement("div", { className: 'nav-groups' },
            !activeTab.noNeedManage &&
                React__default.createElement("div", { className: 'nav-group' },
                    React__default.createElement("div", { className: 'nav-group-left' },
                        React__default.createElement(NavSecondLevelButton, null, "\u7BA1\u7406")),
                    React__default.createElement("div", { className: 'nav-group-right' },
                        React__default.createElement(NavThirdLevelButton, { icon: React__default.createElement(SvgUser, null), onClick: onClickUser }, "\u7528\u6237"),
                        React__default.createElement(NavThirdLevelButton, { icon: React__default.createElement(SvgFile, null), onClick: onClickFile }, "\u6587\u4EF6"),
                        React__default.createElement(NavThirdLevelButton, { icon: React__default.createElement(SvgTask, null), onClick: onClickTask }, "\u4EFB\u52A1"))),
            activeTab.children.map((group, index) => {
                return (React__default.createElement("div", { className: 'nav-group', key: group.text + index },
                    React__default.createElement("div", { className: 'nav-group-left' },
                        React__default.createElement(NavSecondLevelButton, null, group.text)),
                    React__default.createElement("div", { className: 'nav-group-right' }, group.children.map((item, index) => {
                        return (React__default.createElement(NavThirdLevelButton, { key: item.text + index, onClick: item.onClick }, item.text));
                    })),
                    !!group.needDivider && React__default.createElement("div", { className: 'divider' })));
            }))));
}var _g$1, _defs$1;
function _extends$4() { return _extends$4 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4.apply(null, arguments); }
var SvgCloseWhite = function SvgCloseWhite(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g$1 || (_g$1 = /*#__PURE__*/React$1.createElement("g", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    clipPath: "url(#close-white_svg__a)"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "m3.757 3.757 8.486 8.486M12.243 3.757l-8.486 8.486"
  }))), _defs$1 || (_defs$1 = /*#__PURE__*/React$1.createElement("defs", null, /*#__PURE__*/React$1.createElement("clipPath", {
    id: "close-white_svg__a"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};var cjs = {exports: {}};var Draggable$2 = {};var propTypes = {exports: {}};var reactIs = {exports: {}};var reactIs_production_min = {};/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}var reactIs_development = {};/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.AsyncMode = AsyncMode;
	reactIs_development.ConcurrentMode = ConcurrentMode;
	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs.exports;
	hasRequiredReactIs = 1;

	if (process.env.NODE_ENV === 'production') {
	  reactIs.exports = requireReactIs_production_min();
	} else {
	  reactIs.exports = requireReactIs_development();
	}
	return reactIs.exports;
}/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}var has;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has;
	hasRequiredHas = 1;
	has = Function.call.bind(Object.prototype.hasOwnProperty);
	return has;
}/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

var propTypesExports = propTypes.exports;function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}var clsx_m=/*#__PURE__*/Object.freeze({__proto__:null,clsx:clsx,default:clsx});var require$$3 = /*@__PURE__*/getAugmentedNamespace(clsx_m);var domFns = {};var shims = {};Object.defineProperty(shims, "__esModule", {
  value: true
});
shims.dontSetMe = dontSetMe;
shims.findInArray = findInArray;
shims.int = int;
shims.isFunction = isFunction;
shims.isNum = isNum;
// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function findInArray(array /*: Array<any> | TouchList*/, callback /*: Function*/) /*: any*/{
  for (let i = 0, length = array.length; i < length; i++) {
    if (callback.apply(callback, [array[i], i, array])) return array[i];
  }
}
function isFunction(func /*: any*/) /*: boolean %checks*/{
  // $FlowIgnore[method-unbinding]
  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}
function isNum(num /*: any*/) /*: boolean %checks*/{
  return typeof num === 'number' && !isNaN(num);
}
function int(a /*: string*/) /*: number*/{
  return parseInt(a, 10);
}
function dontSetMe(props /*: Object*/, propName /*: string*/, componentName /*: string*/) /*: ?Error*/{
  if (props[propName]) {
    return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
  }
}var getPrefix$1 = {};Object.defineProperty(getPrefix$1, "__esModule", {
  value: true
});
getPrefix$1.browserPrefixToKey = browserPrefixToKey;
getPrefix$1.browserPrefixToStyle = browserPrefixToStyle;
getPrefix$1.default = void 0;
getPrefix$1.getPrefix = getPrefix;
const prefixes = ['Moz', 'Webkit', 'O', 'ms'];
function getPrefix() /*: string*/{
  var _window$document;
  let prop /*: string*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
  // Ensure we're running in an environment where there is actually a global
  // `window` obj
  if (typeof window === 'undefined') return '';

  // If we're in a pseudo-browser server-side environment, this access
  // path may not exist, so bail out if it doesn't.
  const style = (_window$document = window.document) === null || _window$document === void 0 || (_window$document = _window$document.documentElement) === null || _window$document === void 0 ? void 0 : _window$document.style;
  if (!style) return '';
  if (prop in style) return '';
  for (let i = 0; i < prefixes.length; i++) {
    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
  }
  return '';
}
function browserPrefixToKey(prop /*: string*/, prefix /*: string*/) /*: string*/{
  return prefix ? "".concat(prefix).concat(kebabToTitleCase(prop)) : prop;
}
function browserPrefixToStyle(prop /*: string*/, prefix /*: string*/) /*: string*/{
  return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}
function kebabToTitleCase(str /*: string*/) /*: string*/{
  let out = '';
  let shouldCapitalize = true;
  for (let i = 0; i < str.length; i++) {
    if (shouldCapitalize) {
      out += str[i].toUpperCase();
      shouldCapitalize = false;
    } else if (str[i] === '-') {
      shouldCapitalize = true;
    } else {
      out += str[i];
    }
  }
  return out;
}

// Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`
getPrefix$1.default = (getPrefix() /*: string*/);Object.defineProperty(domFns, "__esModule", {
  value: true
});
domFns.addClassName = addClassName;
domFns.addEvent = addEvent;
domFns.addUserSelectStyles = addUserSelectStyles;
domFns.createCSSTransform = createCSSTransform;
domFns.createSVGTransform = createSVGTransform;
domFns.getTouch = getTouch;
domFns.getTouchIdentifier = getTouchIdentifier;
domFns.getTranslation = getTranslation;
domFns.innerHeight = innerHeight;
domFns.innerWidth = innerWidth;
domFns.matchesSelector = matchesSelector;
domFns.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
domFns.offsetXYFromParent = offsetXYFromParent;
domFns.outerHeight = outerHeight;
domFns.outerWidth = outerWidth;
domFns.removeClassName = removeClassName;
domFns.removeEvent = removeEvent;
domFns.removeUserSelectStyles = removeUserSelectStyles;
var _shims$2 = shims;
var _getPrefix = _interopRequireWildcard$1(getPrefix$1);
function _getRequireWildcardCache$1(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache$1 = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard$1(obj, nodeInterop) { if (obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache$1(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/*:: import type {ControlPosition, PositionOffsetControlPosition, MouseTouchEvent} from './types';*/
let matchesSelectorFunc = '';
function matchesSelector(el /*: Node*/, selector /*: string*/) /*: boolean*/{
  if (!matchesSelectorFunc) {
    matchesSelectorFunc = (0, _shims$2.findInArray)(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
      // $FlowIgnore: Doesn't think elements are indexable
      return (0, _shims$2.isFunction)(el[method]);
    });
  }

  // Might not be found entirely (not an Element?) - in that case, bail
  // $FlowIgnore: Doesn't think elements are indexable
  if (!(0, _shims$2.isFunction)(el[matchesSelectorFunc])) return false;

  // $FlowIgnore: Doesn't think elements are indexable
  return el[matchesSelectorFunc](selector);
}

// Works up the tree to the draggable itself attempting to match selector.
function matchesSelectorAndParentsTo(el /*: Node*/, selector /*: string*/, baseNode /*: Node*/) /*: boolean*/{
  let node = el;
  do {
    if (matchesSelector(node, selector)) return true;
    if (node === baseNode) return false;
    // $FlowIgnore[incompatible-type]
    node = node.parentNode;
  } while (node);
  return false;
}
function addEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/, inputOptions /*: Object*/) /*: void*/{
  if (!el) return;
  const options = {
    capture: true,
    ...inputOptions
  };
  // $FlowIgnore[method-unbinding]
  if (el.addEventListener) {
    el.addEventListener(event, handler, options);
  } else if (el.attachEvent) {
    el.attachEvent('on' + event, handler);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = handler;
  }
}
function removeEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/, inputOptions /*: Object*/) /*: void*/{
  if (!el) return;
  const options = {
    capture: true,
    ...inputOptions
  };
  // $FlowIgnore[method-unbinding]
  if (el.removeEventListener) {
    el.removeEventListener(event, handler, options);
  } else if (el.detachEvent) {
    el.detachEvent('on' + event, handler);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = null;
  }
}
function outerHeight(node /*: HTMLElement*/) /*: number*/{
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetTop which is including margin. See getBoundPosition
  let height = node.clientHeight;
  const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height += (0, _shims$2.int)(computedStyle.borderTopWidth);
  height += (0, _shims$2.int)(computedStyle.borderBottomWidth);
  return height;
}
function outerWidth(node /*: HTMLElement*/) /*: number*/{
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetLeft which is including margin. See getBoundPosition
  let width = node.clientWidth;
  const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width += (0, _shims$2.int)(computedStyle.borderLeftWidth);
  width += (0, _shims$2.int)(computedStyle.borderRightWidth);
  return width;
}
function innerHeight(node /*: HTMLElement*/) /*: number*/{
  let height = node.clientHeight;
  const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height -= (0, _shims$2.int)(computedStyle.paddingTop);
  height -= (0, _shims$2.int)(computedStyle.paddingBottom);
  return height;
}
function innerWidth(node /*: HTMLElement*/) /*: number*/{
  let width = node.clientWidth;
  const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width -= (0, _shims$2.int)(computedStyle.paddingLeft);
  width -= (0, _shims$2.int)(computedStyle.paddingRight);
  return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/
// Get from offsetParent
function offsetXYFromParent(evt /*: EventWithOffset*/, offsetParent /*: HTMLElement*/, scale /*: number*/) /*: ControlPosition*/{
  const isBody = offsetParent === offsetParent.ownerDocument.body;
  const offsetParentRect = isBody ? {
    left: 0,
    top: 0
  } : offsetParent.getBoundingClientRect();
  const x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
  const y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
  return {
    x,
    y
  };
}
function createCSSTransform(controlPos /*: ControlPosition*/, positionOffset /*: PositionOffsetControlPosition*/) /*: Object*/{
  const translation = getTranslation(controlPos, positionOffset, 'px');
  return {
    [(0, _getPrefix.browserPrefixToKey)('transform', _getPrefix.default)]: translation
  };
}
function createSVGTransform(controlPos /*: ControlPosition*/, positionOffset /*: PositionOffsetControlPosition*/) /*: string*/{
  const translation = getTranslation(controlPos, positionOffset, '');
  return translation;
}
function getTranslation(_ref /*:: */, positionOffset /*: PositionOffsetControlPosition*/, unitSuffix /*: string*/) /*: string*/{
  let {
    x,
    y
  } /*: ControlPosition*/ = _ref /*: ControlPosition*/;
  let translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");
  if (positionOffset) {
    const defaultX = "".concat(typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
    const defaultY = "".concat(typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
    translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
  }
  return translation;
}
function getTouch(e /*: MouseTouchEvent*/, identifier /*: number*/) /*: ?{clientX: number, clientY: number}*/{
  return e.targetTouches && (0, _shims$2.findInArray)(e.targetTouches, t => identifier === t.identifier) || e.changedTouches && (0, _shims$2.findInArray)(e.changedTouches, t => identifier === t.identifier);
}
function getTouchIdentifier(e /*: MouseTouchEvent*/) /*: ?number*/{
  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}

// User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.

// Note we're passing `document` b/c we could be iframed
function addUserSelectStyles(doc /*: ?Document*/) {
  if (!doc) return;
  let styleEl = doc.getElementById('react-draggable-style-el');
  if (!styleEl) {
    styleEl = doc.createElement('style');
    styleEl.type = 'text/css';
    styleEl.id = 'react-draggable-style-el';
    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
    doc.getElementsByTagName('head')[0].appendChild(styleEl);
  }
  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
}
function removeUserSelectStyles(doc /*: ?Document*/) {
  if (!doc) return;
  try {
    if (doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection');
    // $FlowIgnore: IE
    if (doc.selection) {
      // $FlowIgnore: IE
      doc.selection.empty();
    } else {
      // Remove selection caused by scroll, unless it's a focused input
      // (we use doc.defaultView in case we're in an iframe)
      const selection = (doc.defaultView || window).getSelection();
      if (selection && selection.type !== 'Caret') {
        selection.removeAllRanges();
      }
    }
  } catch (e) {
    // probably IE
  }
}
function addClassName(el /*: HTMLElement*/, className /*: string*/) {
  if (el.classList) {
    el.classList.add(className);
  } else {
    if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) {
      el.className += " ".concat(className);
    }
  }
}
function removeClassName(el /*: HTMLElement*/, className /*: string*/) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), 'g'), '');
  }
}var positionFns = {};Object.defineProperty(positionFns, "__esModule", {
  value: true
});
positionFns.canDragX = canDragX;
positionFns.canDragY = canDragY;
positionFns.createCoreData = createCoreData;
positionFns.createDraggableData = createDraggableData;
positionFns.getBoundPosition = getBoundPosition;
positionFns.getControlPosition = getControlPosition;
positionFns.snapToGrid = snapToGrid;
var _shims$1 = shims;
var _domFns$1 = domFns;
/*:: import type Draggable from '../Draggable';*/
/*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/
/*:: import type DraggableCore from '../DraggableCore';*/
function getBoundPosition(draggable /*: Draggable*/, x /*: number*/, y /*: number*/) /*: [number, number]*/{
  // If no bounds, short-circuit and move on
  if (!draggable.props.bounds) return [x, y];

  // Clone new bounds
  let {
    bounds
  } = draggable.props;
  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
  const node = findDOMNode(draggable);
  if (typeof bounds === 'string') {
    const {
      ownerDocument
    } = node;
    const ownerWindow = ownerDocument.defaultView;
    let boundNode;
    if (bounds === 'parent') {
      boundNode = node.parentNode;
    } else {
      boundNode = ownerDocument.querySelector(bounds);
    }
    if (!(boundNode instanceof ownerWindow.HTMLElement)) {
      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
    }
    const boundNodeEl /*: HTMLElement*/ = boundNode; // for Flow, can't seem to refine correctly
    const nodeStyle = ownerWindow.getComputedStyle(node);
    const boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
    // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
    bounds = {
      left: -node.offsetLeft + (0, _shims$1.int)(boundNodeStyle.paddingLeft) + (0, _shims$1.int)(nodeStyle.marginLeft),
      top: -node.offsetTop + (0, _shims$1.int)(boundNodeStyle.paddingTop) + (0, _shims$1.int)(nodeStyle.marginTop),
      right: (0, _domFns$1.innerWidth)(boundNodeEl) - (0, _domFns$1.outerWidth)(node) - node.offsetLeft + (0, _shims$1.int)(boundNodeStyle.paddingRight) - (0, _shims$1.int)(nodeStyle.marginRight),
      bottom: (0, _domFns$1.innerHeight)(boundNodeEl) - (0, _domFns$1.outerHeight)(node) - node.offsetTop + (0, _shims$1.int)(boundNodeStyle.paddingBottom) - (0, _shims$1.int)(nodeStyle.marginBottom)
    };
  }

  // Keep x and y below right and bottom limits...
  if ((0, _shims$1.isNum)(bounds.right)) x = Math.min(x, bounds.right);
  if ((0, _shims$1.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);

  // But above left and top limits.
  if ((0, _shims$1.isNum)(bounds.left)) x = Math.max(x, bounds.left);
  if ((0, _shims$1.isNum)(bounds.top)) y = Math.max(y, bounds.top);
  return [x, y];
}
function snapToGrid(grid /*: [number, number]*/, pendingX /*: number*/, pendingY /*: number*/) /*: [number, number]*/{
  const x = Math.round(pendingX / grid[0]) * grid[0];
  const y = Math.round(pendingY / grid[1]) * grid[1];
  return [x, y];
}
function canDragX(draggable /*: Draggable*/) /*: boolean*/{
  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
}
function canDragY(draggable /*: Draggable*/) /*: boolean*/{
  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
}

// Get {x, y} positions from event.
function getControlPosition(e /*: MouseTouchEvent*/, touchIdentifier /*: ?number*/, draggableCore /*: DraggableCore*/) /*: ?ControlPosition*/{
  const touchObj = typeof touchIdentifier === 'number' ? (0, _domFns$1.getTouch)(e, touchIdentifier) : null;
  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
  const node = findDOMNode(draggableCore);
  // User can provide an offsetParent if desired.
  const offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
  return (0, _domFns$1.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
}

// Create an data object exposed by <DraggableCore>'s events
function createCoreData(draggable /*: DraggableCore*/, x /*: number*/, y /*: number*/) /*: DraggableData*/{
  const isStart = !(0, _shims$1.isNum)(draggable.lastX);
  const node = findDOMNode(draggable);
  if (isStart) {
    // If this is our first move, use the x and y as last coords.
    return {
      node,
      deltaX: 0,
      deltaY: 0,
      lastX: x,
      lastY: y,
      x,
      y
    };
  } else {
    // Otherwise calculate proper values.
    return {
      node,
      deltaX: x - draggable.lastX,
      deltaY: y - draggable.lastY,
      lastX: draggable.lastX,
      lastY: draggable.lastY,
      x,
      y
    };
  }
}

// Create an data exposed by <Draggable>'s events
function createDraggableData(draggable /*: Draggable*/, coreData /*: DraggableData*/) /*: DraggableData*/{
  const scale = draggable.props.scale;
  return {
    node: coreData.node,
    x: draggable.state.x + coreData.deltaX / scale,
    y: draggable.state.y + coreData.deltaY / scale,
    deltaX: coreData.deltaX / scale,
    deltaY: coreData.deltaY / scale,
    lastX: draggable.state.x,
    lastY: draggable.state.y
  };
}

// A lot faster than stringify/parse
function cloneBounds(bounds /*: Bounds*/) /*: Bounds*/{
  return {
    left: bounds.left,
    top: bounds.top,
    right: bounds.right,
    bottom: bounds.bottom
  };
}
function findDOMNode(draggable /*: Draggable | DraggableCore*/) /*: HTMLElement*/{
  const node = draggable.findDOMNode();
  if (!node) {
    throw new Error('<DraggableCore>: Unmounted during event!');
  }
  // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
  return node;
}var DraggableCore$2 = {};var log$1 = {};Object.defineProperty(log$1, "__esModule", {
  value: true
});
log$1.default = log;
/*eslint no-console:0*/
function log() {
}Object.defineProperty(DraggableCore$2, "__esModule", {
  value: true
});
DraggableCore$2.default = void 0;
var React = _interopRequireWildcard(React__default);
var _propTypes = _interopRequireDefault(propTypesExports);
var _reactDom = _interopRequireDefault(ReactDOM);
var _domFns = domFns;
var _positionFns = positionFns;
var _shims = shims;
var _log = _interopRequireDefault(log$1);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/
/*:: import type {Element as ReactElement} from 'react';*/
// Simple abstraction for dragging events names.
const eventsFor = {
  touch: {
    start: 'touchstart',
    move: 'touchmove',
    stop: 'touchend'
  },
  mouse: {
    start: 'mousedown',
    move: 'mousemove',
    stop: 'mouseup'
  }
};

// Default to mouse events.
let dragEventFor = eventsFor.mouse;
/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/
/*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/
/*:: export type ControlPosition = {x: number, y: number};*/
/*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/
/*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/
/*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/
//
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//

let DraggableCore$1=class DraggableCore extends React.Component /*:: <DraggableCoreProps>*/{
  constructor() {
    super(...arguments);
    _defineProperty(this, "dragging", false);
    // Used while dragging to determine deltas.
    _defineProperty(this, "lastX", NaN);
    _defineProperty(this, "lastY", NaN);
    _defineProperty(this, "touchIdentifier", null);
    _defineProperty(this, "mounted", false);
    _defineProperty(this, "handleDragStart", e => {
      // Make it possible to attach event handlers on top of this one.
      this.props.onMouseDown(e);

      // Only accept left-clicks.
      if (!this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;

      // Get nodes. Be sure to grab relative document (could be iframed)
      const thisNode = this.findDOMNode();
      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
        throw new Error('<DraggableCore> not mounted on DragStart!');
      }
      const {
        ownerDocument
      } = thisNode;

      // Short circuit if handle or cancel prop was provided and selector doesn't match.
      if (this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, this.props.handle, thisNode) || this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, this.props.cancel, thisNode)) {
        return;
      }

      // Prevent scrolling on mobile devices, like ipad/iphone.
      // Important that this is after handle/cancel.
      if (e.type === 'touchstart') e.preventDefault();

      // Set touch identifier in component state if this is a touch event. This allows us to
      // distinguish between individual touches on multitouch screens by identifying which
      // touchpoint was set to this element.
      const touchIdentifier = (0, _domFns.getTouchIdentifier)(e);
      this.touchIdentifier = touchIdentifier;

      // Get the current drag point from the event. This is used as the offset.
      const position = (0, _positionFns.getControlPosition)(e, touchIdentifier, this);
      if (position == null) return; // not possible but satisfies flow
      const {
        x,
        y
      } = position;

      // Create an event object with all the data parents need to make a decision here.
      const coreEvent = (0, _positionFns.createCoreData)(this, x, y);
      (0, _log.default)('DraggableCore: handleDragStart: %j', coreEvent);

      // Call event handler. If it returns explicit false, cancel.
      (0, _log.default)('calling', this.props.onStart);
      const shouldUpdate = this.props.onStart(e, coreEvent);
      if (shouldUpdate === false || this.mounted === false) return;

      // Add a style to the body to disable user-select. This prevents text from
      // being selected all over the page.
      if (this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument);

      // Initiate dragging. Set the current x and y as offsets
      // so we know how much we've moved during the drag. This allows us
      // to drag elements around even if they have been moved, without issue.
      this.dragging = true;
      this.lastX = x;
      this.lastY = y;

      // Add events to the document directly so we catch when the user's mouse/touch moves outside of
      // this element. We use different events depending on whether or not we have detected that this
      // is a touch-capable device.
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, this.handleDrag);
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, this.handleDragStop);
    });
    _defineProperty(this, "handleDrag", e => {
      // Get the current drag point from the event. This is used as the offset.
      const position = (0, _positionFns.getControlPosition)(e, this.touchIdentifier, this);
      if (position == null) return;
      let {
        x,
        y
      } = position;

      // Snap to grid if prop has been provided
      if (Array.isArray(this.props.grid)) {
        let deltaX = x - this.lastX,
          deltaY = y - this.lastY;
        [deltaX, deltaY] = (0, _positionFns.snapToGrid)(this.props.grid, deltaX, deltaY);
        if (!deltaX && !deltaY) return; // skip useless drag
        x = this.lastX + deltaX, y = this.lastY + deltaY;
      }
      const coreEvent = (0, _positionFns.createCoreData)(this, x, y);
      (0, _log.default)('DraggableCore: handleDrag: %j', coreEvent);

      // Call event handler. If it returns explicit false, trigger end.
      const shouldUpdate = this.props.onDrag(e, coreEvent);
      if (shouldUpdate === false || this.mounted === false) {
        try {
          // $FlowIgnore
          this.handleDragStop(new MouseEvent('mouseup'));
        } catch (err) {
          // Old browsers
          const event = ((document.createEvent('MouseEvents') /*: any*/) /*: MouseTouchEvent*/);
          // I see why this insanity was deprecated
          // $FlowIgnore
          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
          this.handleDragStop(event);
        }
        return;
      }
      this.lastX = x;
      this.lastY = y;
    });
    _defineProperty(this, "handleDragStop", e => {
      if (!this.dragging) return;
      const position = (0, _positionFns.getControlPosition)(e, this.touchIdentifier, this);
      if (position == null) return;
      let {
        x,
        y
      } = position;

      // Snap to grid if prop has been provided
      if (Array.isArray(this.props.grid)) {
        let deltaX = x - this.lastX || 0;
        let deltaY = y - this.lastY || 0;
        [deltaX, deltaY] = (0, _positionFns.snapToGrid)(this.props.grid, deltaX, deltaY);
        x = this.lastX + deltaX, y = this.lastY + deltaY;
      }
      const coreEvent = (0, _positionFns.createCoreData)(this, x, y);

      // Call event handler
      const shouldContinue = this.props.onStop(e, coreEvent);
      if (shouldContinue === false || this.mounted === false) return false;
      const thisNode = this.findDOMNode();
      if (thisNode) {
        // Remove user-select hack
        if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
      }
      (0, _log.default)('DraggableCore: handleDragStop: %j', coreEvent);

      // Reset the el.
      this.dragging = false;
      this.lastX = NaN;
      this.lastY = NaN;
      if (thisNode) {
        // Remove event handlers
        (0, _log.default)('DraggableCore: Removing handlers');
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, this.handleDrag);
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, this.handleDragStop);
      }
    });
    _defineProperty(this, "onMouseDown", e => {
      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse

      return this.handleDragStart(e);
    });
    _defineProperty(this, "onMouseUp", e => {
      dragEventFor = eventsFor.mouse;
      return this.handleDragStop(e);
    });
    // Same as onMouseDown (start drag), but now consider this a touch device.
    _defineProperty(this, "onTouchStart", e => {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;
      return this.handleDragStart(e);
    });
    _defineProperty(this, "onTouchEnd", e => {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;
      return this.handleDragStop(e);
    });
  }
  componentDidMount() {
    this.mounted = true;
    // Touch handlers must be added with {passive: false} to be cancelable.
    // https://developers.google.com/web/updates/2017/01/scrolling-intervention
    const thisNode = this.findDOMNode();
    if (thisNode) {
      (0, _domFns.addEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
        passive: false
      });
    }
  }
  componentWillUnmount() {
    this.mounted = false;
    // Remove any leftover event handlers. Remove both touch and mouse handlers in case
    // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
    const thisNode = this.findDOMNode();
    if (thisNode) {
      const {
        ownerDocument
      } = thisNode;
      (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
      (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
      (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
      (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
      (0, _domFns.removeEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
        passive: false
      });
      if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument);
    }
  }

  // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
  // the underlying DOM node ourselves. See the README for more information.
  findDOMNode() /*: ?HTMLElement*/{
    var _this$props, _this$props2;
    return (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.nodeRef ? (_this$props2 = this.props) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.nodeRef) === null || _this$props2 === void 0 ? void 0 : _this$props2.current : _reactDom.default.findDOMNode(this);
  }
  render() /*: React.Element<any>*/{
    // Reuse the child provided
    // This makes it flexible to use whatever element is wanted (div, ul, etc)
    return /*#__PURE__*/React.cloneElement(React.Children.only(this.props.children), {
      // Note: mouseMove handler is attached to document so it will still function
      // when the user drags quickly and leaves the bounds of the element.
      onMouseDown: this.onMouseDown,
      onMouseUp: this.onMouseUp,
      // onTouchStart is added on `componentDidMount` so they can be added with
      // {passive: false}, which allows it to cancel. See
      // https://developers.google.com/web/updates/2017/01/scrolling-intervention
      onTouchEnd: this.onTouchEnd
    });
  }
};
DraggableCore$2.default = DraggableCore$1;
_defineProperty(DraggableCore$1, "displayName", 'DraggableCore');
_defineProperty(DraggableCore$1, "propTypes", {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired,
  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: _propTypes.default.bool,
  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: _propTypes.default.bool,
  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function (props /*: DraggableCoreProps*/, propName /*: $Keys<DraggableCoreProps>*/) {
    if (props[propName] && props[propName].nodeType !== 1) {
      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
    }
  },
  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: _propTypes.default.arrayOf(_propTypes.default.number),
  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: _propTypes.default.string,
  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: _propTypes.default.string,
  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */
  nodeRef: _propTypes.default.object,
  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: _propTypes.default.func,
  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: _propTypes.default.func,
  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: _propTypes.default.func,
  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: _propTypes.default.func,
  /**
   * `scale`, if set, applies scaling while dragging an element
   */
  scale: _propTypes.default.number,
  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
});
_defineProperty(DraggableCore$1, "defaultProps", {
  allowAnyClick: false,
  // by default only accept left click
  disabled: false,
  enableUserSelectHack: true,
  onStart: function () {},
  onDrag: function () {},
  onStop: function () {},
  onMouseDown: function () {},
  scale: 1
});(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "DraggableCore", {
	  enumerable: true,
	  get: function () {
	    return _DraggableCore.default;
	  }
	});
	exports.default = void 0;
	var React = _interopRequireWildcard(React__default);
	var _propTypes = _interopRequireDefault(propTypesExports);
	var _reactDom = _interopRequireDefault(ReactDOM);
	var _clsx = _interopRequireDefault(require$$3);
	var _domFns = domFns;
	var _positionFns = positionFns;
	var _shims = shims;
	var _DraggableCore = _interopRequireDefault(DraggableCore$2);
	var _log = _interopRequireDefault(log$1);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
	function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /*:: import type {ControlPosition, PositionOffsetControlPosition, DraggableCoreProps, DraggableCoreDefaultProps} from './DraggableCore';*/
	/*:: import type {Bounds, DraggableEventHandler} from './utils/types';*/
	/*:: import type {Element as ReactElement} from 'react';*/
	/*:: type DraggableState = {
	  dragging: boolean,
	  dragged: boolean,
	  x: number, y: number,
	  slackX: number, slackY: number,
	  isElementSVG: boolean,
	  prevPropsPosition: ?ControlPosition,
	};*/
	/*:: export type DraggableDefaultProps = {
	  ...DraggableCoreDefaultProps,
	  axis: 'both' | 'x' | 'y' | 'none',
	  bounds: Bounds | string | false,
	  defaultClassName: string,
	  defaultClassNameDragging: string,
	  defaultClassNameDragged: string,
	  defaultPosition: ControlPosition,
	  scale: number,
	};*/
	/*:: export type DraggableProps = {
	  ...DraggableCoreProps,
	  ...DraggableDefaultProps,
	  positionOffset: PositionOffsetControlPosition,
	  position: ControlPosition,
	};*/
	//
	// Define <Draggable>
	//
	class Draggable extends React.Component /*:: <DraggableProps, DraggableState>*/{
	  // React 16.3+
	  // Arity (props, state)
	  static getDerivedStateFromProps(_ref /*:: */, _ref2 /*:: */) /*: ?Partial<DraggableState>*/{
	    let {
	      position
	    } /*: DraggableProps*/ = _ref /*: DraggableProps*/;
	    let {
	      prevPropsPosition
	    } /*: DraggableState*/ = _ref2 /*: DraggableState*/;
	    // Set x/y if a new position is provided in props that is different than the previous.
	    if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
	      (0, _log.default)('Draggable: getDerivedStateFromProps %j', {
	        position,
	        prevPropsPosition
	      });
	      return {
	        x: position.x,
	        y: position.y,
	        prevPropsPosition: {
	          ...position
	        }
	      };
	    }
	    return null;
	  }
	  constructor(props /*: DraggableProps*/) {
	    super(props);
	    _defineProperty(this, "onDragStart", (e, coreData) => {
	      (0, _log.default)('Draggable: onDragStart: %j', coreData);

	      // Short-circuit if user's callback killed it.
	      const shouldStart = this.props.onStart(e, (0, _positionFns.createDraggableData)(this, coreData));
	      // Kills start event on core as well, so move handlers are never bound.
	      if (shouldStart === false) return false;
	      this.setState({
	        dragging: true,
	        dragged: true
	      });
	    });
	    _defineProperty(this, "onDrag", (e, coreData) => {
	      if (!this.state.dragging) return false;
	      (0, _log.default)('Draggable: onDrag: %j', coreData);
	      const uiData = (0, _positionFns.createDraggableData)(this, coreData);
	      const newState = {
	        x: uiData.x,
	        y: uiData.y,
	        slackX: 0,
	        slackY: 0
	      };

	      // Keep within bounds.
	      if (this.props.bounds) {
	        // Save original x and y.
	        const {
	          x,
	          y
	        } = newState;

	        // Add slack to the values used to calculate bound position. This will ensure that if
	        // we start removing slack, the element won't react to it right away until it's been
	        // completely removed.
	        newState.x += this.state.slackX;
	        newState.y += this.state.slackY;

	        // Get bound position. This will ceil/floor the x and y within the boundaries.
	        const [newStateX, newStateY] = (0, _positionFns.getBoundPosition)(this, newState.x, newState.y);
	        newState.x = newStateX;
	        newState.y = newStateY;

	        // Recalculate slack by noting how much was shaved by the boundPosition handler.
	        newState.slackX = this.state.slackX + (x - newState.x);
	        newState.slackY = this.state.slackY + (y - newState.y);

	        // Update the event we fire to reflect what really happened after bounds took effect.
	        uiData.x = newState.x;
	        uiData.y = newState.y;
	        uiData.deltaX = newState.x - this.state.x;
	        uiData.deltaY = newState.y - this.state.y;
	      }

	      // Short-circuit if user's callback killed it.
	      const shouldUpdate = this.props.onDrag(e, uiData);
	      if (shouldUpdate === false) return false;
	      this.setState(newState);
	    });
	    _defineProperty(this, "onDragStop", (e, coreData) => {
	      if (!this.state.dragging) return false;

	      // Short-circuit if user's callback killed it.
	      const shouldContinue = this.props.onStop(e, (0, _positionFns.createDraggableData)(this, coreData));
	      if (shouldContinue === false) return false;
	      (0, _log.default)('Draggable: onDragStop: %j', coreData);
	      const newState /*: Partial<DraggableState>*/ = {
	        dragging: false,
	        slackX: 0,
	        slackY: 0
	      };

	      // If this is a controlled component, the result of this operation will be to
	      // revert back to the old position. We expect a handler on `onDragStop`, at the least.
	      const controlled = Boolean(this.props.position);
	      if (controlled) {
	        const {
	          x,
	          y
	        } = this.props.position;
	        newState.x = x;
	        newState.y = y;
	      }
	      this.setState(newState);
	    });
	    this.state = {
	      // Whether or not we are currently dragging.
	      dragging: false,
	      // Whether or not we have been dragged before.
	      dragged: false,
	      // Current transform x and y.
	      x: props.position ? props.position.x : props.defaultPosition.x,
	      y: props.position ? props.position.y : props.defaultPosition.y,
	      prevPropsPosition: {
	        ...props.position
	      },
	      // Used for compensating for out-of-bounds drags
	      slackX: 0,
	      slackY: 0,
	      // Can only determine if SVG after mounting
	      isElementSVG: false
	    };
	    if (props.position && !(props.onDrag || props.onStop)) {
	      // eslint-disable-next-line no-console
	      console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
	    }
	  }
	  componentDidMount() {
	    // Check to see if the element passed is an instanceof SVGElement
	    if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) {
	      this.setState({
	        isElementSVG: true
	      });
	    }
	  }
	  componentWillUnmount() {
	    this.setState({
	      dragging: false
	    }); // prevents invariant if unmounted while dragging
	  }

	  // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
	  // the underlying DOM node ourselves. See the README for more information.
	  findDOMNode() /*: ?HTMLElement*/{
	    var _this$props$nodeRef$c, _this$props;
	    return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 || (_this$props = _this$props.nodeRef) === null || _this$props === void 0 ? void 0 : _this$props.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : _reactDom.default.findDOMNode(this);
	  }
	  render() /*: ReactElement<any>*/{
	    const {
	      axis,
	      bounds,
	      children,
	      defaultPosition,
	      defaultClassName,
	      defaultClassNameDragging,
	      defaultClassNameDragged,
	      position,
	      positionOffset,
	      scale,
	      ...draggableCoreProps
	    } = this.props;
	    let style = {};
	    let svgTransform = null;

	    // If this is controlled, we don't want to move it - unless it's dragging.
	    const controlled = Boolean(position);
	    const draggable = !controlled || this.state.dragging;
	    const validPosition = position || defaultPosition;
	    const transformOpts = {
	      // Set left if horizontal drag is enabled
	      x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : validPosition.x,
	      // Set top if vertical drag is enabled
	      y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : validPosition.y
	    };

	    // If this element was SVG, we use the `transform` attribute.
	    if (this.state.isElementSVG) {
	      svgTransform = (0, _domFns.createSVGTransform)(transformOpts, positionOffset);
	    } else {
	      // Add a CSS transform to move the element around. This allows us to move the element around
	      // without worrying about whether or not it is relatively or absolutely positioned.
	      // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
	      // has a clean slate.
	      style = (0, _domFns.createCSSTransform)(transformOpts, positionOffset);
	    }

	    // Mark with class while dragging
	    const className = (0, _clsx.default)(children.props.className || '', defaultClassName, {
	      [defaultClassNameDragging]: this.state.dragging,
	      [defaultClassNameDragged]: this.state.dragged
	    });

	    // Reuse the child provided
	    // This makes it flexible to use whatever element is wanted (div, ul, etc)
	    return /*#__PURE__*/React.createElement(_DraggableCore.default, _extends({}, draggableCoreProps, {
	      onStart: this.onDragStart,
	      onDrag: this.onDrag,
	      onStop: this.onDragStop
	    }), /*#__PURE__*/React.cloneElement(React.Children.only(children), {
	      className: className,
	      style: {
	        ...children.props.style,
	        ...style
	      },
	      transform: svgTransform
	    }));
	  }
	}
	exports.default = Draggable;
	_defineProperty(Draggable, "displayName", 'Draggable');
	_defineProperty(Draggable, "propTypes", {
	  // Accepts all props <DraggableCore> accepts.
	  ..._DraggableCore.default.propTypes,
	  /**
	   * `axis` determines which axis the draggable can move.
	   *
	   *  Note that all callbacks will still return data as normal. This only
	   *  controls flushing to the DOM.
	   *
	   * 'both' allows movement horizontally and vertically.
	   * 'x' limits movement to horizontal axis.
	   * 'y' limits movement to vertical axis.
	   * 'none' limits all movement.
	   *
	   * Defaults to 'both'.
	   */
	  axis: _propTypes.default.oneOf(['both', 'x', 'y', 'none']),
	  /**
	   * `bounds` determines the range of movement available to the element.
	   * Available values are:
	   *
	   * 'parent' restricts movement within the Draggable's parent node.
	   *
	   * Alternatively, pass an object with the following properties, all of which are optional:
	   *
	   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
	   *
	   * All values are in px.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *         return (
	   *            <Draggable bounds={{right: 300, bottom: 300}}>
	   *              <div>Content</div>
	   *           </Draggable>
	   *         );
	   *       }
	   *   });
	   * ```
	   */
	  bounds: _propTypes.default.oneOfType([_propTypes.default.shape({
	    left: _propTypes.default.number,
	    right: _propTypes.default.number,
	    top: _propTypes.default.number,
	    bottom: _propTypes.default.number
	  }), _propTypes.default.string, _propTypes.default.oneOf([false])]),
	  defaultClassName: _propTypes.default.string,
	  defaultClassNameDragging: _propTypes.default.string,
	  defaultClassNameDragged: _propTypes.default.string,
	  /**
	   * `defaultPosition` specifies the x and y that the dragged item should start at
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */
	  defaultPosition: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }),
	  positionOffset: _propTypes.default.shape({
	    x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    y: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	  }),
	  /**
	   * `position`, if present, defines the current position of the element.
	   *
	   *  This is similar to how form elements in React work - if no `position` is supplied, the component
	   *  is uncontrolled.
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable position={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */
	  position: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }),
	  /**
	   * These properties should be defined on the child, not here.
	   */
	  className: _shims.dontSetMe,
	  style: _shims.dontSetMe,
	  transform: _shims.dontSetMe
	});
	_defineProperty(Draggable, "defaultProps", {
	  ..._DraggableCore.default.defaultProps,
	  axis: 'both',
	  bounds: false,
	  defaultClassName: 'react-draggable',
	  defaultClassNameDragging: 'react-draggable-dragging',
	  defaultClassNameDragged: 'react-draggable-dragged',
	  defaultPosition: {
	    x: 0,
	    y: 0
	  },
	  scale: 1
	}); 
} (Draggable$2));const {
  default: Draggable,
  DraggableCore
} = Draggable$2;

// Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266
cjs.exports = Draggable;
cjs.exports.default = Draggable;
cjs.exports.DraggableCore = DraggableCore;

var cjsExports = cjs.exports;
var Draggable$1 = /*@__PURE__*/getDefaultExportFromCjs(cjsExports);function TnModal$1(props) {
    const [canDrag, setCanDrag] = useState(props.canDrag != null ? props.canDrag : true);
    const [modalDragDisabled, setModalDragDisabled] = useState(true);
    const [showHeader, setShowHeader] = useState(props.showHeader != null ? props.showHeader : true);
    const draggleRef = React__default.createRef();
    const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 });
    const onModalDragStart = (_, uiData) => {
        var _a, _b;
        if (!canDrag)
            return;
        const { clientWidth, clientHeight } = (_a = window === null || window === void 0 ? void 0 : window.document) === null || _a === void 0 ? void 0 : _a.documentElement;
        const targetRect = (_b = draggleRef === null || draggleRef === void 0 ? void 0 : draggleRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        setBounds({
            left: -(targetRect === null || targetRect === void 0 ? void 0 : targetRect.left) + (uiData === null || uiData === void 0 ? void 0 : uiData.x),
            right: clientWidth - ((targetRect === null || targetRect === void 0 ? void 0 : targetRect.right) - (uiData === null || uiData === void 0 ? void 0 : uiData.x)),
            top: -(targetRect === null || targetRect === void 0 ? void 0 : targetRect.top) + (uiData === null || uiData === void 0 ? void 0 : uiData.y),
            bottom: clientHeight - ((targetRect === null || targetRect === void 0 ? void 0 : targetRect.bottom) - (uiData === null || uiData === void 0 ? void 0 : uiData.y)),
        });
    };
    const ModalDragger = (React__default.createElement("div", { className: 'modal-header', onMouseOver: () => {
            setModalDragDisabled(false);
        }, onMouseOut: () => {
            setModalDragDisabled(true);
        } },
        (props === null || props === void 0 ? void 0 : props.title) || "标题",
        React__default.createElement("div", { onClick: props.onCancel },
            React__default.createElement(SvgCloseWhite, null))));
    return (React__default.createElement(Modal, { wrapClassName: `tn-base-modal ${props.wrapClassName ? props.wrapClassName : ''}`, open: props.open, onCancel: props.onCancel, footer: null, closable: false, title: showHeader ? ModalDragger : null, destroyOnClose: true, width: props.width || 396, mask: props === null || props === void 0 ? void 0 : props.mask, modalRender: modal => (React__default.createElement(Draggable$1, { disabled: modalDragDisabled, bounds: bounds, onStart: (event, uiData) => onModalDragStart(event, uiData) },
            React__default.createElement("div", { ref: draggleRef }, modal))) },
        React__default.createElement("div", { className: 'modal-container' },
            React__default.createElement("div", { className: 'modal-body' }, props.children),
            (!!props.showFooter || props.showFooter == null) && (React__default.createElement("div", { className: 'modal-footer' },
                React__default.createElement(Button, { primary: true, onClick: props.onSave, disabled: props.loading }, "\u786E\u5B9A"),
                React__default.createElement(Button, { danger: true, onClick: props.onCancel }, "\u53D6\u6D88"))))));
}function TnModal() {
    const deleteModal = (props) => {
        const instance = Modal.confirm({
            title: '删除',
            content: props.content || '是否确认删除？',
            wrapClassName: classNames({
                'tn-modal-panel': true,
                'closable-hidden': !props.closable
            }),
            icon: null,
            onCancel: () => {
                if (props.onCancel) {
                    props.onCancel();
                }
                else {
                    Modal.destroyAll();
                }
            },
            footer: (React__default.createElement("div", { className: 'tn-modal-footer' },
                React__default.createElement(Button, { primary: true, onClick: () => {
                        if (props.onOk)
                            props.onOk();
                    } }, "\u786E\u5B9A"),
                React__default.createElement(Button, { danger: true, onClick: () => {
                        if (props.onCancel) {
                            props.onCancel();
                        }
                        else {
                            Modal.destroyAll();
                        }
                    } }, "\u53D6\u6D88")))
        });
        return instance;
    };
    const specialDeleteModal = (props) => {
        const instance = Modal.confirm({
            closable: props.closable,
            title: props.title ? props.title : '删除',
            content: props.content ? props.content : '是否确认删除？',
            wrapClassName: classNames({
                'tn-modal-panel': true,
                'closable-hidden': !props.closable
            }),
            icon: null,
            onCancel: () => {
                if (props.onClose) {
                    props.onClose();
                }
                else {
                    Modal.destroyAll();
                }
            },
            footer: (React__default.createElement("div", { className: 'tn-modal-footer' },
                React__default.createElement(Button, { primary: true, onClick: () => {
                        if (props.onOk)
                            props.onOk();
                    } }, props.okText ? props.okText : '确定'),
                React__default.createElement(Button, { danger: true, onClick: () => {
                        if (props.onCancel) {
                            props.onCancel();
                        }
                        else {
                            Modal.destroyAll();
                        }
                    } }, props.cancelText ? props.cancelText : '取消')))
        });
        return instance;
    };
    const baseModal = (props) => {
        const title = props.title ? props.title : "删除";
        const content = props.content ? props.content : "是否确认删除？";
        const okText = props.okText ? props.okText : "确定";
        const cancelText = props.cancelText ? props.cancelText : "取消";
        const instance = Modal.confirm({
            title: title,
            content: content,
            wrapClassName: classNames({
                'tn-modal-panel': true,
                'closable-hidden': !props.closable
            }),
            icon: null,
            onCancel: () => {
                if (props.onCancel) {
                    props.onCancel();
                }
                else {
                    Modal.destroyAll();
                }
            },
            footer: (React__default.createElement("div", { className: 'tn-modal-footer' },
                React__default.createElement(Button, { primary: true, onClick: () => {
                        if (props.onOk)
                            props.onOk();
                    } }, okText),
                React__default.createElement(Button, { danger: true, onClick: () => {
                        if (props.onCancel) {
                            props.onCancel();
                        }
                        else {
                            Modal.destroyAll();
                        }
                    } }, cancelText)))
        });
        return instance;
    };
    const destoryAll = () => {
        Modal.destroyAll();
    };
    return {
        deleteModal, baseModal, destoryAll, specialDeleteModal
    };
}var _path$1;
function _extends$3() { return _extends$3 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3.apply(null, arguments); }
var SvgNewDefault32 = function SvgNewDefault32(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React$1.createElement("path", {
    stroke: "#11788F",
    strokeLinecap: "round",
    strokeWidth: 2.897,
    d: "M1.933 18h32.134M18 1.933v32.134"
  })));
};var _path;
function _extends$2() { return _extends$2 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2.apply(null, arguments); }
var SvgNewDefault32White = function SvgNewDefault32White(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React$1.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 2.897,
    d: "M1.933 18h32.134M18 1.933v32.134"
  })));
};function IconBase(props) {
    const { svg, className } = props, rest = __rest(props, ["svg", "className"]);
    return (React__default.createElement("span", Object.assign({ className: classNames({
            "icon-base": true,
        }, className) }, rest), svg));
}const Child = (props) => {
    const { leftItemContainer, leftItem, leftItemUpdateUuid } = props;
    const memoizedLeftItemContainer = useMemo(() => {
        return leftItemContainer ? React__default.createElement(leftItemContainer, { leftItem }) : null;
    }, [leftItem, leftItemUpdateUuid]);
    // 直接返回 memoizedLeftItemContainer
    return memoizedLeftItemContainer;
};
function LeftSideList(props) {
    const { leftItems, uniqueKey, activeLeftItemKey, onClickLeftItem, onDbClickLeftItem, onContextMenuLeftItem, leftItemContainer, noNeedAddIcon, onClickAddIcon, children, wrapClassName, style, normalAddSvg, activeAddSvg, minStyle, leftItemUpdateUuid } = props;
    return (React__default.createElement("div", { className: classNames({
            'left-side-container': true,
            'left-side-container-min': minStyle
        }, wrapClassName), style: style },
        React__default.createElement("div", { className: 'left-side-list' },
            leftItems.map(leftItem => {
                return (React__default.createElement("div", { className: classNames({
                        'left-item': true,
                        'active': activeLeftItemKey === leftItem[uniqueKey]
                    }), onClick: (e) => {
                        onClickLeftItem === null || onClickLeftItem === void 0 ? void 0 : onClickLeftItem(e, leftItem);
                    }, key: leftItem[uniqueKey], onDoubleClick: (e) => {
                        onDbClickLeftItem === null || onDbClickLeftItem === void 0 ? void 0 : onDbClickLeftItem(e, leftItem);
                    }, onContextMenu: (e) => {
                        onContextMenuLeftItem === null || onContextMenuLeftItem === void 0 ? void 0 : onContextMenuLeftItem(e, leftItem);
                    } },
                    React__default.createElement(Child, { leftItem: leftItem, leftItemContainer: leftItemContainer, leftItemUpdateUuid: leftItemUpdateUuid })));
            }),
            (noNeedAddIcon == null || !noNeedAddIcon) &&
                React__default.createElement("div", { className: 'add-left', onClick: onClickAddIcon },
                    React__default.createElement(IconBase, { svg: normalAddSvg ? normalAddSvg : React__default.createElement(SvgNewDefault32, null), className: "normal" }),
                    React__default.createElement(IconBase, { svg: activeAddSvg ? activeAddSvg : React__default.createElement(SvgNewDefault32White, null), className: "active" }))),
        children));
}var DetailInfoRowType;
(function (DetailInfoRowType) {
    DetailInfoRowType[DetailInfoRowType["TEXT"] = 0] = "TEXT";
    DetailInfoRowType[DetailInfoRowType["INPUT"] = 1] = "INPUT";
    DetailInfoRowType[DetailInfoRowType["SELECT"] = 2] = "SELECT";
})(DetailInfoRowType || (DetailInfoRowType = {}));
/**
 * 数据行组件
 * @param props
 * @returns
 */
function DetailInfoRow(props) {
    const { label, textValue, currentValue, children, isEditing, onChange, values, type } = props;
    return (React__default.createElement("div", { className: 'detail-info-row' },
        label != null && typeof label === 'string' && React__default.createElement("span", { className: 'label' }, label),
        label != null && typeof label !== 'string' && label,
        children != null && children,
        children == null && !isEditing && React__default.createElement("span", { className: 'value' }, textValue),
        children == null && isEditing && type === DetailInfoRowType.TEXT && React__default.createElement("span", { className: 'value' }, currentValue),
        children == null && isEditing && type === DetailInfoRowType.INPUT && React__default.createElement(Input, { wrapClassName: 'value-input', value: currentValue, onChange: onChange }),
        children == null && isEditing && type === DetailInfoRowType.SELECT && React__default.createElement(Dropdown, { wrapClassName: 'value-select', value: currentValue, onChange: onChange, options: values })));
}function ModelListIcon(props) {
    return (React__default.createElement(IconBase, { svg: React__default.createElement(SvgProjectList, null), className: props.className, style: props.style }));
}var _g, _defs;
function _extends$1() { return _extends$1 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1.apply(null, arguments); }
var SvgCircleConfirm = function SvgCircleConfirm(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React$1.createElement("g", {
    stroke: "#11788F",
    clipPath: "url(#circle-confirm_svg__a)"
  }, /*#__PURE__*/React$1.createElement("circle", {
    cx: 8,
    cy: 8.844,
    r: 6.813
  }), /*#__PURE__*/React$1.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m4.06 8.627 2.826 2.843 4.83-5.445"
  }))), _defs || (_defs = /*#__PURE__*/React$1.createElement("defs", null, /*#__PURE__*/React$1.createElement("clipPath", {
    id: "circle-confirm_svg__a"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "#fff",
    d: "M0 .844h16v16H0z"
  })))));
};var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgUncheck = function SvgUncheck(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React$1.createElement("rect", {
    width: 13,
    height: 13,
    x: 1.5,
    y: 1.5,
    fill: "#fff",
    rx: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React$1.createElement("rect", {
    width: 13,
    height: 13,
    x: 1.5,
    y: 1.5,
    stroke: "#C6CCCD",
    rx: 1.5
  })));
};function DataRow(props) {
    const { data, index, editUuid, inputValue, setInputValue, onDataBlur, onClickData, onContextData, selectedDataUuids, active, onActivate } = props;
    const [isHovered, setIsHovered] = useState(false);
    const handleStatusIconClick = (e) => {
        e.stopPropagation(); // 阻止事件冒泡，避免触发整个行的点击事件
        if (onActivate) {
            onActivate(data.uuid); // 调用外部激活逻辑
        }
    };
    return (React__default.createElement("div", { className: classNames('data-row', {
            active: selectedDataUuids.includes(data === null || data === void 0 ? void 0 : data.uuid),
            hovered: isHovered,
        }), onClick: (e) => onClickData(e, data, index), onContextMenu: (e) => onContextData(e, data), onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false) },
        React__default.createElement("div", { className: "status-icon", onClick: handleStatusIconClick }, active ? React__default.createElement(SvgCircleConfirm, null) : React__default.createElement(SvgUncheck, null)),
        React__default.createElement("span", { className: "data-index" }, (index + 1).toString().padStart(3, '0')),
        editUuid !== data.uuid && (React__default.createElement("span", { className: "data-name ellipsis" }, data === null || data === void 0 ? void 0 : data.name)),
        editUuid === data.uuid && (React__default.createElement(Input, { value: inputValue, onChange: (e) => setInputValue(e.target.value), onBlur: onDataBlur, placeholder: "\u8BF7\u8F93\u5165\u540D\u79F0", autoFocus: true, onEnter: onDataBlur }))));
}export{Breadcrumb,Button,ButtonBase,ContextMenu,ContextMenuModal,ContextMenuWrapper,DataRow,DetailInfoRow,DetailInfoRowType,Dropdown,FloatModal,Header,IconBase,IconButton,Input,InputDropdown,LeftSideList,Logo,MenuItem,MenuList,TnModal$1 as Modal,ModelListIcon,ModelListItem,Nav,NavFirstLevelButton,NavSecondLevelButton,NavSecondLevelMenu,NavSecondLevelTag,NavThirdLevelButton,SelectDot,SideHeader,Tab,TabMenuItem,TnModal};